import { render, staticRenderFns } from "./PresetDeleteArea.vue?vue&type=template&id=a86b6bf4&scoped=true&"
import script from "./PresetDeleteArea.vue?vue&type=script&lang=ts&"
export * from "./PresetDeleteArea.vue?vue&type=script&lang=ts&"
import style0 from "./PresetDeleteArea.vue?vue&type=style&index=0&id=a86b6bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86b6bf4",
  null
  
)

export default component.exports